import IonToolbar from '../../../../../components/Modal/ModalToolbar';
import { IonButton, IonButtons, IonContent, IonDatetime, IonFooter, IonHeader, IonIcon, IonInput, IonLabel, IonList, IonListHeader, IonLoading, IonModal, IonPopover, IonSelect, IonSelectOption, IonTextarea, IonTitle, IonToast } from '@ionic/react';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router';
import "./FinanceiroLancamentos.css";

import { Toast } from '@capacitor/toast';
import { Buffer } from 'buffer';
import { arrowBack } from 'ionicons/icons';
import 'moment/locale/pt-br';
import { empresaCarregar, incluirFinanceiro, requestService } from '../../../../../Utils/Services';
import { MessageContext } from '../../../../../contexts/MessageContext';

type Props = {
  projetoid: any;
  tipo: any;
  observacao: any;
  closeAction: Function;
  closeActionSimple: Function;
};

const FinanceiroLancamentos: React.FC<Props> = (props: Props) => {

  const history = useHistory<any>();
  const location = useLocation<any>();
  const [showLoading, setShowLoading] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [textToast, setTextToast] = useState("");
  const [showModalTipoLancamento, setShowModalTipoLancamento] = useState(false);
  const [observacoes, setObservacoes] = useState<any>();
  const [cobranca, setCobranca] = useState<any>();
  const [dataLancamento, setDataLancamento] = useState<any>();
  const [dataLancamentoBr, setDataLancamentoBr] = useState<any>();
  const [botaoAtivo, setBotaoAtivo] = useState(true);
  const [categoria, setCategoria] = useState<any>();
  const [listaCategoria, setListaCategoria] = useState<any>([]);
  // const [listaUsuario, setListaUsuario] = useState<any>([]);
  const [projeto, setProjeto] = useState<string>("");
  // const [listaProjeto, setListaProjeto] = useState<any>([]);
  const [showModalDataCad, setShowModalDataCad] = useState(false);

  const [valor, setValor] = useState<any>();

  const popover1 = useRef<HTMLIonPopoverElement>(null);

  const [acessos] = useState<any>(JSON.parse(window.localStorage.getItem("acessos") || '{}'));
  const { loja, setLoja } = useContext(MessageContext);

  const [checkedEnviarMensagem, setCheckedEnviarMensagem] = useState(false);
  const [tipo, setTipo] = useState<string>("");

  const [fecharTipoLancamento, setFecharTipoLancamento] = useState(false);

  const [opcoes, setOpcoes] = useState<string>("unica");
  const [parcelas, setParcelas] = useState<string>("");

  const { recarregarFinanceiro, setRecarregarFinanceiro } = useContext(MessageContext);

  let params: any = {
    projetoid: ""
  }

  params = useParams();

  if (location && location.state && location.state.projetoid) {
    params.projetoid = location.state.projetoid;
  }

  if (props.projetoid) {
    params = {
      projetoid: props.projetoid
    }
  }

  useEffect(() => {

    console.log("props.projetoid", props.projetoid);
    if (props.projetoid != null) {
      let id = atob(props.projetoid);
      console.log("props.projetoid", props.projetoid);
      setProjeto(id);


      console.log("entrou no useEffect", id);
    }
  }, [props.projetoid]);


  useEffect(() => {
    console.log("*******************", props.observacao);
    if (props.observacao != null) {
      setObservacoes(props.observacao);
    }
  }, [props.observacao]);

  useEffect(() => {
    if (props.tipo != null) {
      setTipo(props.tipo);
      setFecharTipoLancamento(true);
      avancarLancamento();
    }
  }, [props.tipo]);


  async function avancarLancamento() {

    setCategoria("");


    let data = new Date().toString();
    const dataFormatada = new Intl.DateTimeFormat('pt-BR', { timeZone: 'UTC' }).format(
      Date.parse(data)
    );
    setDataLancamentoBr(dataFormatada);
    setDataLancamento(data);

    setValor("");

    console.log("projeto", projeto);
    //setProjeto("");

    setCheckedEnviarMensagem(false);
    setCobranca("");

    const consultarEmpresa = async () => {
      requestService(empresaCarregar.url.replace("{id}", loja.replaceAll(/#/g, '%23')).concat("?filtro=", Buffer.from(loja).toString("base64")), {

        method: empresaCarregar.method,
        headers: [
          ["token", window.localStorage.getItem("token")]
        ],
        credentials: 'include'
      },
        history,
        (response: any) => {
          console.log("response_empresa", response);
          if (tipo == "receita") {
            setListaCategoria(response.Item.categoriaReceita || []);
          }
          else {
            setListaCategoria(response.Item.categoriaDespesa || []);
          }

        },
        (error: any) => {
          console.log(error);
          setTextToast("Ocorreu um erro ao carregar as informações, tente novamente em instantes.");
          setShowToast(true);
        });
    }

    // const consultarProjeto = async () => {

    //   let token: string = "";
    //   const tkn = localStorage.getItem("token");
    //   if (typeof (tkn) === "string") {
    //     token = tkn;
    //   }

    //   let montarUrl = projetoLista.url.replace("{loja}", loja.replaceAll(/#/g, "%23"));
    //   const resp = await fetch(montarUrl,
    //     {
    //       method: "GET",
    //       headers: [
    //         ["token", token]
    //       ],
    //       credentials: 'include'
    //     });
    //   let projetos = await resp.json();
    //   console.log("projetos", projetos);
    //   if (resp.status === 400 || resp.status === 401) {
    //     setTextToast("Ocorreu um erro ao carregar as informações, tente novamente em instantes.");
    //     setShowToast(true);
    //   }
    //   else {
    //     if (projetos.Items) {
    //       let lista = projetos.Items.sort((a: any, b: any) => {
    //         const nomeProjetoA = typeof a.nomeProjeto === 'string' ? a.nomeProjeto.toLowerCase() : '';
    //         const nomeProjetoB = typeof b.nomeProjeto === 'string' ? b.nomeProjeto.toLowerCase() : '';

    //         if (nomeProjetoA > nomeProjetoB) return 1;
    //         if (nomeProjetoA < nomeProjetoB) return -1;
    //         return 0;
    //       });
    //       setListaProjeto(lista);
    //     }
    //   }
    // }

    await consultarEmpresa();
    // await consultarProjeto();

    setShowModalTipoLancamento(true);

  }

  function validarCamposLancamento() {


    if (categoria.length === 0) {
      setTextToast("Campo Categoria é obrigatório.");
      setShowToast(true);
      return false;
    }

    if (tipo.length === 0) {
      setTextToast("Campo Tipo é obrigatório.");
      setShowToast(true);
      return false;
    }

    if (valor.length === 0) {
      setTextToast("Campo Valor é obrigatório.");
      setShowToast(true);
      return false;
    }

    if (opcoes == "parcelas" && parcelas == "") {
      setTextToast("Campo parcela é obrigatório.");
      setShowToast(true);
      return false;
    }

    let dia = Number(dataLancamento.substring(0, 10).split("-")[2]);
    console.log("diaaa", dia)

    if (opcoes != "unica" && dia > 28) {
      setTextToast("O dia da parcela precisa ser menor que 29.");
      setShowToast(true);
      return false;
    }

    return true;
  }

  function iniciarLancamento() {

    if (!validarCamposLancamento())
      return;


    if (botaoAtivo) {
      setShowLoading(true);
      setBotaoAtivo(false);

      // let found;
      // found = listaProjeto.find((obj: any) => {
      //   return obj.pk === projeto;
      // });


      // console.log("found", found);

      let objRequest = {
        "categoria": categoria,
        "observacoes": observacoes,
        "tipo": tipo,
        "data": new Date(dataLancamento),
        "valor": valor,
        "projetoid": projeto || "",
        // "nomeProjeto": found?.nomeProjeto || "",
        "empresaid": loja || "",
        // "clienteid": found?.clienteid || "",
        "opcoes": opcoes || "",
        "parcelas": parcelas || "",
        "enviarMensagem": checkedEnviarMensagem,
        "cobranca": cobranca
      };

      console.log("objRequest", objRequest);


      requestService(incluirFinanceiro.url, {
        method: incluirFinanceiro.method,
        headers: [
          ["token", window.localStorage.getItem("token")]
        ],
        body: JSON.stringify(objRequest),
        credentials: 'include'
      },
        history,
        (response: any) => {

          console.log("response_incluirFinanceiro", response);
          if (response.message) {
            setShowModalTipoLancamento(false);
            setRecarregarFinanceiro(true);
            props.closeAction();
            Toast.show({
              text: "Lançamento criado com sucesso!",
              position: "center",
              duration: "long"
            });
          }
        },
        (error: any) => {
          console.log(error);
          setShowLoading(false);
          Toast.show({
            text: "Não foi possível concluir a operação, tente novamente em instantes.",
            position: "center",
            duration: "long"
          });
        })
    }

    setShowLoading(false);
    setBotaoAtivo(true);
  }

  // function readProjeto() {
  //   return listaProjeto.map((value: any, index: any, array: any) =>
  //   (
  //     <IonSelectOption key={value.pk} value={value.pk}>{value.nomeProjeto}</IonSelectOption>
  //   )
  //   )
  // };

  function readCategoria() {
    return listaCategoria.map((value: any, index: any, array: any) =>
    (
      <IonSelectOption key={value} value={value}>{value}</IonSelectOption>
    )
    )
  };

  const openPopoverCad = (e: any) => {
    popover1.current!.event = e;
    setShowModalDataCad(true);
  };

  function onChangeValor(e: any) {

    e.persist();
    e.preventDefault();

    let v = e.target.value;

    v = v.replace(/\d{9}/, '');
    v = v.replace(/\D/g, '');
    v = v.replace(/(\d{1})(\d{1,2})$/, "$1,$2");
    v = v.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
    v = v.replace(/^(\d)/g, "$1");

    setValor(v);
  }

  return (

    <>
      <IonHeader className="ion-no-border">
        <IonToolbar>
          <IonButtons slot="start">
            <IonButton onClick={() => { props.closeActionSimple() }}>
              <IonIcon slot="icon-only" icon={arrowBack} />
            </IonButton>
          </IonButtons>
          <IonTitle>Novo lançamento</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent className="financeiro-form-content">

        <IonList lines="full" class="ion-no-margin">
          <IonListHeader className="financeiro-form-intro">
            <IonLabel className="financeiro-field-label">
              Qual tipo de lançamento deseja realizar?
            </IonLabel>
          </IonListHeader>
          <div className="financeiro-field" >
            <IonLabel className="financeiro-field-label">Lançamento*</IonLabel>
            <IonSelect aria-label="Tipo de lançamento" name='Tipo' value={tipo} multiple={false} placeholder="Selecione" cancelText="Cancel" okText="Ok" onIonChange={e => {
              setTipo(e.detail.value);
            }}>

              <IonSelectOption value="receita">Receita</IonSelectOption>
              <IonSelectOption value="despesa">Despesa</IonSelectOption>
            </IonSelect>
          </div>
        </IonList>

        <div className="content">


          <IonModal isOpen={showModalTipoLancamento} onDidDismiss={() => {
            setShowModalTipoLancamento(false)
            if (fecharTipoLancamento) {
              props.closeActionSimple();
            }
          }

          } >
            <IonHeader className="ion-no-border">
              <IonToolbar>
                <IonTitle>Nova {tipo}</IonTitle>
                <IonButtons slot="start" onClick={() => { setShowModalTipoLancamento(false); }}>
                  <IonIcon slot="icon-only" icon={arrowBack}></IonIcon>
                </IonButtons>
              </IonToolbar>
            </IonHeader>
            <IonContent className="financeiro-form-content">
              <IonList lines="full" class="ion-no-margin">

                <div className="financeiro-field">
                  <IonLabel className="financeiro-field-label">Categoria*</IonLabel>
                  <IonSelect aria-label="Categoria" value={categoria} placeholder="Selecione" onIonChange={e => { setCategoria(e.detail.value); }}>
                    {readCategoria()}
                  </IonSelect>
                </div>


                <div className="financeiro-field">
                  <IonLabel className="financeiro-field-label">Data*</IonLabel>
                  <button type="button" className="financeiro-date-field" aria-label="Selecionar data do lançamento" onClick={e => { openPopoverCad(e); }}>{dataLancamentoBr}</button>
                </div>

                <div className="financeiro-field">
                  <IonLabel className="financeiro-field-label">Valor*</IonLabel>
                  <IonInput aria-label="Valor" type="tel" maxlength={14} placeholder="Digite o valor" value={valor} onKeyUp={onChangeValor} />
                </div>


                <div className="financeiro-field">
                  <IonLabel className="financeiro-field-label">Observações</IonLabel>
                  <IonTextarea aria-label="Observações" rows={6} value={observacoes} maxlength={250} placeholder="" onIonInput={(e: any) => setObservacoes(e.target.value)}></IonTextarea>
                </div>


                <div className="financeiro-field" hidden={checkedEnviarMensagem == false}>
                  <IonLabel className="financeiro-field-label">Cobrança</IonLabel>
                  <IonTextarea aria-label="Cobrança" rows={6} value={cobranca} maxlength={250} placeholder="" onIonInput={(e: any) => setCobranca(e.target.value)}></IonTextarea>
                </div>


              </IonList>

            </IonContent>
            <IonFooter className="ion-no-border financeiro-form-footer">
              <IonToolbar>
                <IonButton expand="block" size='large' color="primary" onClick={() => { iniciarLancamento(); }}>Registrar</IonButton>
              </IonToolbar>
            </IonFooter>
          </IonModal>

          <IonPopover ref={popover1}
            isOpen={showModalDataCad}
            onDidDismiss={() => setShowModalDataCad(false)} >
            <IonContent>
              <IonDatetime

                presentation='date'

                onIonChange={e => {

                  if (e.detail.value) {
                    let data = e.detail.value.toString().substring(0, 10);
                    const dataFormatada = new Intl.DateTimeFormat('pt-BR', { timeZone: 'UTC' }).format(
                      Date.parse(data)
                    );
                    setDataLancamentoBr(dataFormatada);
                    setDataLancamento(data);
                  }
                  //setShowModalDataCad(false);
                }}></IonDatetime>
            </IonContent>
          </IonPopover >

          <IonToast
            isOpen={showToast}
            position="middle" //top, bottom, middle
            onDidDismiss={() => setShowToast(false)}
            message={textToast}
            duration={3000}
          />
        </div>

        <IonLoading
          cssClass='my-custom-class'
          isOpen={showLoading}
          onDidDismiss={() => { setShowLoading(false); }}
          spinner='circles'
        />

      </IonContent>
      <IonFooter className="ion-no-border financeiro-form-footer">
        <IonToolbar>
          <IonButton expand="block" size='large' color="primary" onClick={() => {
            if (tipo) {
              setObservacoes("");
              avancarLancamento();
            }
            else {
              setTextToast("Precisa selecionar o tipo para criar um lançamento.");
              setShowToast(true);

            }
          }}>Avançar</IonButton>
        </IonToolbar>
      </IonFooter>

    </>
  );


};

export default ({ projetoid, tipo, observacao, closeAction, closeActionSimple }: { projetoid: any, tipo: any, observacao: any, closeAction: Function, closeActionSimple: Function }) => (
  <FinanceiroLancamentos projetoid={projetoid} tipo={tipo} observacao={observacao} closeAction={closeAction} closeActionSimple={closeActionSimple}>
  </FinanceiroLancamentos>
)
